import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";

import finsallLogo from "../../assets/images/Logo Full Blue 1.png";

const NotFound: React.FC = () => {
  return (
    <div className="not-found-page">

      <div className="not-found-wrapper">

        <Link to="/">
          <img
            src={finsallLogo}
            alt="Finsall Logo"
            className="not-found-logo"
          />
        </Link>

        <h1 className="not-found-title">
          404 Page Not Found !
        </h1>

      </div>

    </div>
  );
};

export default NotFound;